class scrollController {
    constructor(el) {
        //get the basics and start the visibility observer
        this.scroller = el; //Main element
        this.items = this.scroller.querySelector('.scroll-control-items'); //Items div
        this.scrollbar = this.scroller.querySelector('.scroll-control-scrollbar'); //Scrollbar
        this.scrollprogress = this.scroller.querySelector('.scroll-control-progress'); //Progress block
        this.scrollnext = this.scroller.querySelector('.scroll-control-next'); //Next
        this.scrollprev = this.scroller.querySelector('.scroll-control-prev'); //Previous
        this.scrollerviewwidth = 0; // width of the scrollers div in the view
        this.itemswidth = 0; // total width of the items including overflow
        this.scrollbarwidth = 0; // scrollbar width
        this.progresswidth = 0; // progress
        this.altmode = this.scroller.classList.contains('alt-mode');
        this.debugmode = this.scroller.classList.contains('debug-mode');
        this.altscrolldist = 0;
        //Disable Alt mode on mobile
        var screenwidth = document.body.clientWidth;
        if (screenwidth < 768) {
            console.log('mobile');
            this.altmode = false;
        }
        this.visibilityObserver();
    }

    setValues() {
        //Sets the current values the scroller is working against
        this.scrollerviewwidth = this.scroller.offsetWidth;
        this.itemswidth = this.items.scrollWidth;
        this.scrollbarwidth = this.scrollbar.offsetWidth;
        const viewtoitems = this.scrollerviewwidth / this.itemswidth;
        this.progresswidth = this.scrollbarwidth * viewtoitems;
        this.scrollprogress.style.width = this.progresswidth + "px";
        this.maxaltscroll = this.itemswidth - (this.scrollerviewwidth/2);
        this.altscrollrange = this.scrollbarwidth - this.progresswidth;
    }

    setEvents() {
        //Click events etc
        const instance = this;
        //Scroll event
        this.items.addEventListener('scroll', function () {
            requestAnimationFrame((e) => {
                instance.updateScroller()
            });
        });

        //Click to scroll
        this.scrollbar.addEventListener('click', function (e) {
            const target = e.target;
            const rect = target.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const perc = x / instance.scrollbarwidth;
            instance.items.scrollTo({
                top: 0,
                left: instance.itemswidth * perc,
                behavior: 'smooth'
            });
            instance.altscrolldist = instance.itemswidth * perc;
            if (instance.altscrolldist >= instance.maxaltscroll) {
                instance.altscrolldist = instance.maxaltscroll
            }
            instance.items.style.transform = "translateX(-" + instance.altscrolldist + "px)";
            instance.updateScroller();
        })

        //Next
        this.scrollnext.addEventListener('click', function (e) {
            if (instance.altmode) {
                if (instance.altscrolldist < instance.maxaltscroll) {
                    instance.altscrolldist = instance.altscrolldist + (instance.scrollerviewwidth * 0.8);

                    if (instance.altscrolldist >= instance.maxaltscroll) {
                        instance.altscrolldist = instance.maxaltscroll
                    }
                    instance.items.style.transform = "translateX(-" + instance.altscrolldist + "px)";
                    instance.updateScroller();
                }
            } else {
                instance.items.scrollTo({
                    top: 0,
                    left: instance.items.scrollLeft + (instance.scrollerviewwidth * 0.8),
                    behavior: 'smooth'
                });
            }

        })

        //Prev
        this.scrollprev.addEventListener('click', function (e) {
            if (instance.altmode) {
                if (instance.altscrolldist > 0) {
                    instance.altscrolldist = instance.altscrolldist - (instance.scrollerviewwidth * 0.8);
                    if (instance.altscrolldist <= 0) {
                        instance.altscrolldist = 0
                    }
                    instance.items.style.transform = "translateX(-" + instance.altscrolldist + "px)";
                    instance.updateScroller();
                } else {
                    instance.altscrolldist = 0;
                }
            } else {
                instance.items.scrollTo({
                    top: 0,
                    left: instance.items.scrollLeft - (instance.scrollerviewwidth * 0.8),
                    behavior: 'smooth'
                });
            }
        })
    }

    // Method
    load() {
        //Load the scroller
        this.setValues();
        this.setEvents();
        this.dragScroll();
        this.resizeObserver();
        this.debug();
        this.scroller.classList.add('loaded');
    }

    visibilityObserver() {
        //No point loading it unless its visible
        let el = this.scroller;
        var options = {
            root: null,
        };
        var observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!el.classList.contains('loaded')) {
                        this.load(el);
                        if (this.debugmode) {
                            this.debug();
                        }
                    }
                }
            });
        }, options);
        observer.observe(el);
    }

    resizeObserver() {
        //Check if the scroller div has resized, (bootstrap mostly fixed widths in responsive so no need to trigger on viewport change)
        let el = this.scroller;
        var options = {
            root: null,
        };
        var observer = new ResizeObserver((entries, observer) => {
            this.setValues();
        }, options);
        observer.observe(el);
    }

    dragScroll() {
        //For drag scrolling on desktop
        const slider = this.items;
        if (slider != undefined) {
            let isDown = false;
            let startX;
            let scrollLeft;

            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                startX = e.pageX - slider.offsetLeft;
                if (this.altmode) {
                    scrollLeft = this.altscrolldist;
                } else {
                    scrollLeft = slider.scrollLeft;
                }
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('scrolling');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('scrolling');
            });
            slider.addEventListener('mousemove', (e) => {
                e.preventDefault();
                if (!isDown) {
                    return;
                }
                slider.classList.add('scrolling');
                const x = e.pageX - slider.offsetLeft;


                if (this.altmode) {
                    const walk = (x - startX); //scroll-fast
                    this.altscrolldist = scrollLeft - walk;
                    if (this.altscrolldist <= 0) {
                        this.altscrolldist = 0
                    }
                    if (this.altscrolldist >= this.maxaltscroll) {
                        this.altscrolldist = this.maxaltscroll
                    }
                    this.items.style.transform = "translateX(-" + this.altscrolldist + "px)";
                    this.updateScroller();

                } else {
                    const walk = (x - startX) * 2; //scroll-fast
                    slider.scrollLeft = scrollLeft - walk;
                }
            });
        }
    }

    updateScroller() {
        //Update scrollbar progress
        if (this.altmode) {
            let progress = (this.altscrolldist / this.maxaltscroll);
            this.scrollprogress.style.transform = 'translateX(' + (this.altscrollrange * progress) + 'px)';
        } else {
            let progress = (this.items.scrollLeft / this.itemswidth);
            this.scrollprogress.style.transform = 'translateX(' + (this.scrollbarwidth * progress) + 'px)';
        }
    }

    debug() {
        console.table({
            'Alt Mode?': this.altmode,
            'View Width': this.scrollerviewwidth,
            'Items Width': this.itemswidth,
            'Scroll Width': this.scrollbarwidth,
            'Progress Width': this.progresswidth,
        });
    }
}

export default scrollController;
